import { AbilityBuilder, PureAbility } from '@casl/ability';

type Actions = 'read' | 'create' | 'update' | 'delete' | 'manage';
type Subjects = 'AdminPage' | 'ManagerPage' | 'UserPage' | 'all';

/**
 * Define las habilidades de un usuario según su rol.
 * @param role - Rol del usuario (por ejemplo: 'superuser', 'admin', 'manager', 'costumer').
 * @returns Una instancia de PureAbility que describe qué acciones puede realizar el usuario.
 */
export const defineAbilitiesFor = (role: string): PureAbility<[Actions, Subjects]> => {
    const { can, cannot, build } = new AbilityBuilder<PureAbility<[Actions, Subjects]>>(PureAbility);

    if (role === 'superuser') {
        can('manage', 'all');
    } else if (role === 'admin') {
        can('read', 'AdminPage');
        can('update', 'AdminPage');
        can('create', 'AdminPage');
        can('delete', 'AdminPage');
    } else if (role === 'manager') {
        can('read', 'ManagerPage');
        can('create', 'ManagerPage');
        can('update', 'ManagerPage');
        can('delete', 'ManagerPage');
        cannot('update', 'AdminPage');
        cannot('create', 'AdminPage');
        cannot('delete', 'AdminPage');
    } else if (role === 'costumer') {
        can('read', 'UserPage');
        cannot('read', 'AdminPage');
        cannot('update', 'AdminPage');
        cannot('create', 'AdminPage');
        cannot('delete', 'AdminPage');
    }

    return build();
};
